export default "__VITE_ASSET__KaEtoZ0JCR8K$z$RN1Ww6A__"